// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agents/followups/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/agents/followups/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Khách đang chờ" })
  return <Page />
}
